module.exports={"No matching results":"일치하는 결과가 없습니다.","Show suggestion":"제안 사항 표시","Show {0} suggestions":"{0}제안 사항 표시","Show suggestions":"제안 사항 표시"};